import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-1 items-center gap-3 min-w-0" }
const _hoisted_2 = {
  key: 1,
  class: "flex-1 min-w-0"
}
const _hoisted_3 = { class: "text-lg font-semibold text-black m-0 truncate text-left max-[600px]:w-full max-[600px]:whitespace-normal max-[600px]:overflow-visible" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-black"
}
const _hoisted_5 = { class: "flex items-center gap-2 shrink-0" }
const _hoisted_6 = { class: "hidden md:contents" }
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = {
  key: 1,
  class: "md:hidden fixed bottom-[65px] left-0 right-0 z-50 bg-white/60 backdrop-blur-lg border-t border-gray-100/50 px-5 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]"
}
const _hoisted_9 = { class: "flex justify-center [&>button]:w-full [&>button]:justify-center [&>button]:py-3 [&>button]:rounded-xl [&>button]:font-semibold [&>button]:shadow-lg" }
const _hoisted_10 = {
  key: 2,
  class: "mt-6 pt-4 border-t border-gray-200"
}

interface Props {
  title?: string;
  subtitle?: string;
  icon?: string;
  iconColor?: string;
  iconBgColor?: string;
  hoverable?: boolean;
  clickable?: boolean;
  className?: string;
}

// Props réactives

export default /*@__PURE__*/_defineComponent({
  __name: 'DataCard',
  props: {
    title: {},
    subtitle: {},
    icon: {},
    iconColor: {},
    iconBgColor: {},
    hoverable: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    className: { default: '' }
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'bg-white rounded-xl shadow-sm border border-gray-200 p-6 transition-all duration-300',
      _ctx.hoverable && 'hover:shadow-lg hover:border-gray-300 hover:transform hover:-translate-y-1',
      _ctx.clickable && 'cursor-pointer',
      _ctx.className
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickable && _ctx.$emit('click')))
  }, [
    (_ctx.title || _ctx.icon || _ctx.$slots['header-actions'] || _ctx.$slots['header-toggle'])
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['flex flex-wrap items-center justify-between gap-2 mb-4', _ctx.$slots['header-toggle'] && 'max-[600px]:flex-nowrap'])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.icon)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
          'w-10 h-10 shrink-0 rounded-full text-center flex items-center justify-center',
          _ctx.iconBgColor || 'bg-blue-100'
        ])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass([_ctx.icon, _ctx.iconColor || 'text-blue-600'])
                  }, null, 2)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$slots['title-after'] && 'flex items-center gap-2 max-[600px]:flex-col max-[600px]:items-start max-[600px]:gap-0')
                  }, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _renderSlot(_ctx.$slots, "title-after")
                  ], 2),
                  (_ctx.subtitle)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "header-toggle"),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "header-actions")
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.$slots['header-actions'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "header-actions")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})